let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2mJlZ")).then(() => parcelRequire('1H71o'));